/* -----------------Globals--------------- */
import { ActivityIndicator } from "react-native-paper";

/* -----------------Child components--------------- */
import Box from "../Box";
import EmptyView from "../EmptyView";
import { ChatList } from "./ChatList";

/* -----------------Types--------------- */
import type { MessagesViewProps } from "./types/props";

import { defaultAiAssistantInfo } from "@memorang/helpers/src/aiAssistant";
/* -----------------Helpers & Hooks--------------- */

const ailaEmptyStateImg =
	"https://memorang-prod-media.s3.amazonaws.com/aila_empty.png";
export const MessagesView = ({
	messages,
	messageActions,
	isRecommendedQuestionsFetching,
	loading,
	streaming,
	recommendedQueries = [],
	handleSelectQuery,
	loader,
	context,
	handleNavigateToReference,
	emptyStateProps,
	showReference,
	showSummarizeResponse,
	referenceThumbnails,
	assistantInfo = defaultAiAssistantInfo,
	isThreadLoading,
	isItemAnswered = true,
	textToSpeach,
}: MessagesViewProps) => {
	const showRecommendedChipsLoading =
		!(loading || streaming) && isRecommendedQuestionsFetching;

	if (isThreadLoading) {
		return (
			<Box flex={1} height="100%" justifyContent="center" alignItems="center">
				<ActivityIndicator size="large" />
			</Box>
		);
	}

	const emptyViewSubtitle = isItemAnswered
		? `Ask anything related to ${context}`
		: `${assistantInfo.alias} will activate after you answer the question`;

	return (
		<Box gap={8} height="100%">
			{messages?.length && isItemAnswered ? (
				<ChatList
					assistantInfo={assistantInfo}
					messages={messages}
					loader={loader}
					showRecommendedChipsLoading={showRecommendedChipsLoading}
					recommendedQueries={recommendedQueries}
					handleSelectQuery={handleSelectQuery}
					handleNavigateToReference={handleNavigateToReference}
					showReference={showReference}
					showSummarizeResponse={showSummarizeResponse}
					messageActions={messageActions}
					referenceThumbnails={referenceThumbnails}
					textToSpeach={textToSpeach}
				/>
			) : (
				<EmptyView
					title={`${assistantInfo.alias} is your AI-Powered Learning Assistant`}
					subtitle={emptyViewSubtitle}
					image={{ uri: ailaEmptyStateImg }}
					{...emptyStateProps}
				/>
			)}
		</Box>
	);
};
